export const STATUSES = {
  DRAFTS: {
    value: 'drafts',
    color: 'default',
  },
  ACTIVE: {
    value: 'active',
    color: 'success',
  },
  INACTIVE: {
    value: 'inactive',
    color: 'secondary',
  },
  RETURN: {
    value: 'return',
    color: 'error',
  },
  WORKING: {
    value: 'working',
    color: 'warning',
  },
  BANNED: {
    value: 'banned',
    color: 'error',
  },
  NONE: {
    value: 'none',
    color: 'default',
  },
  PARTLY: {
    value: 'banned',
    color: 'warning',
  },
  DONE: {
    value: 'banned',
    color: 'success',
  },
  NOT_PAID: { value: 'not_paid', color: 'default' },
  PARTIALLY_PAID: { value: 'partially_paid', color: 'warning' },
  FULLY_PAID: { value: 'fully_paid', color: 'success' },
  COMPLETED: { value: 'completed', color: 'success' },
  NOT_DELIVERED: { value: 'not_delivered', color: 'default' },
  PARTIALLY_DELIVERED: { value: 'partially_delivered', color: 'warning' },
  FULLY_DELIVERED: { value: 'fully_delivered', color: 'success' },
  /** Ozon FBS/FBO posting — как вкладки категорий в скроллере */
  AWAITING: { value: 'awaiting', color: 'default' },
  DELIVERING: { value: 'delivering', color: 'warning' },
  DELIVERED: { value: 'delivered', color: 'success' },
  CANCELLED: { value: 'cancelled', color: 'error' },
};

export const SYNC_STATUSES = {
  none: {
    value: 'none',
    color: 'default',
  },
  working: {
    value: 'working',
    color: 'warning',
  },
  failed: {
    value: 'failed',
    color: 'error',
  },
  done: {
    value: 'done',
    color: 'success',
  }
}
